import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { add } from 'date-fns';
import moment from 'moment';
// Modals
import { Notification } from 'src/app/models/AppNotification';
// globals
import { PAYMENT_SUMMARY_FILTER_DURATION } from 'src/globals';

export type IPaymentType = 'ExcessBaggage'; // businessTransactionType [ NewBusiness, Amendment, Refund, Cancellation, ExcessBaggage, ManualRefund, DriverTip, GooglePay, ApplePay, ExtraBagDoorstep, CustomsCharge ]
export type IStatusTypes = 'Paid' | 'UnPaid' | 'ALL';

export interface ICustomFilter {
    paymentType: IPaymentType;
    startDate: Date | null;
    endDate: Date | null;
    status: IStatusTypes;
    airport: string;
}

const startDate = moment().startOf('month').toDate();
const endDate = moment().endOf('month').toDate();

interface PaymentState {
    search: string;
    hasfilterApplied: boolean;
    hasSearchFiltersApplied: boolean;
    resolvedNofication: Notification;
    penddingToBeResolved: boolean;
    customFilter: ICustomFilter;
}

interface UpdatePendingNotification {
    resolvedNofication: Notification | null;
    penddingToBeResolved: boolean;
}

const initialState: PaymentState = {
    search: '',

    hasfilterApplied: false,
    hasSearchFiltersApplied: false,

    customFilter: {
        paymentType: 'ExcessBaggage',
        startDate: startDate,
        endDate: endDate,
        status: 'ALL',
        airport: 'ALL',
    },
    resolvedNofication: {} as Notification,
    penddingToBeResolved: false,
};

export const paymentSlice = createSlice({
    name: 'payments',
    initialState,
    reducers: {
        setSearchFilter: (state, action: PayloadAction<string>) => {
            state.search = action.payload;
        },
        setStartDate: (state, action: PayloadAction<Date | null>) => {
            state.customFilter.startDate = action.payload;
            state.customFilter.endDate = add(action.payload, { days: PAYMENT_SUMMARY_FILTER_DURATION });
            state.search = '';
            state.hasfilterApplied = true;
        },
        setEndDate: (state, action: PayloadAction<Date | null>) => {
            state.customFilter.endDate = action.payload;
            state.search = '';
            state.hasfilterApplied = true;
        },
        setPaymentType: (state, action: PayloadAction<IPaymentType>) => {
            state.customFilter.paymentType = action.payload;
            state.search = '';
            state.hasfilterApplied = true;
        },
        setStatusFilter: (state, action: PayloadAction<IStatusTypes>) => {
            state.customFilter.status = action.payload;
            state.search = '';
            state.hasfilterApplied = true;
        },
        setAirportFilter: (state, action: PayloadAction<string>) => {
            state.customFilter.airport = action.payload;
            state.search = '';
            state.hasfilterApplied = true;
        },
        applySearch: (state) => {
            state.hasSearchFiltersApplied = true;
            state.hasfilterApplied = true;

            // reset other filters to apply search
            state.customFilter.status = 'ALL';
            state.customFilter.paymentType = 'ExcessBaggage';
            state.customFilter.airport = 'ALL';
            state.customFilter.startDate = startDate;
            state.customFilter.endDate = endDate;
        },
        updatePendingNotification: (state, action: PayloadAction<UpdatePendingNotification>) => {
            state.resolvedNofication = action.payload.resolvedNofication;
            state.penddingToBeResolved = action.payload.penddingToBeResolved;
        },
        clearAllFilters: (state) => {
            state.hasSearchFiltersApplied = false;
            state.hasfilterApplied = false;

            state.search = '';
            state.customFilter.status = 'ALL';
            state.customFilter.paymentType = 'ExcessBaggage';
            state.customFilter.airport = 'ALL';
            state.customFilter.startDate = startDate;
            state.customFilter.endDate = endDate;
        },
    },
});

export const {
    setSearchFilter,
    setAirportFilter,
    setPaymentType,
    setStartDate,
    setEndDate,
    setStatusFilter,
    applySearch,
    clearAllFilters,
    updatePendingNotification,
} = paymentSlice.actions;
export default paymentSlice.reducer;
